export default "__VITE_ASSET__TEYPJB$p__"